export enum EMaterialType {
  timeline = 'timeline',
  transcript = 'transcript',
  chat = 'chat',
}

export enum EProcessStatus {
  notStarted = 'NotStarted',
  processing = 'Processing',
  notRequired = 'NotRequired',
  done = 'Done',
  error = 'Error',
}

export enum EAnalyticsStatus {
  ok = 'Ok',
  problem = 'Problem',
  failed = 'Failed',
  processing = 'Processing',
}

export enum ETrackingSource {
  chat = 'chat',
  title = 'title',
}

export enum EMatchingType {
  bonus = 'bonus',
  matched = 'matched',
  missing = 'missing',
  planned = 'planned',
  unrelated = 'unrelated',
  other = 'other',
}

export enum EManualMatchingStatus {
  matched = 'matched',
  unmatched = 'unmatched',
}

export enum EFindingType {
  audioTracking = 'audioTracking',
  caption = 'caption',
  chatBot = 'chatBot',
  chatbotMulti = 'chatbotMulti',
  content = 'content',
  description = 'description',
  gamePlay = 'gamePlay',
  hashtag = 'hashtag',
  mention = 'mention',
  message = 'message',
  productPlacement = 'productPlacement',
  showcase = 'showcase',
  textTracking = 'textTracking',
  title = 'title',
  topic = 'topic',
  visual = 'visual',
  custom = 'custom',
  talkingPointAi = 'topicAi',
}

export enum EAnalyticsSentiment {
  positive = 'positive',
  neutral = 'neutral',
  negative = 'negative',
}

export enum ETalkingPointAiSource {
  transcript = 'transcript',
  chat = 'chat',
}
